import { ITranslations } from '@llws/lift-entity-interfaces';

export const getNewTranslation = (
  clientId: number,
  foreignId: number,
  languageId: number,
  key: string,
  model: string,
  relatedId?: number,
) => {
  const translation: ITranslations = {
    clientId,
    foreignId,
    languageId,
    relatedId,
    key,
    model,
    created: new Date(),
    value: '',
    id: undefined,
  };

  return translation;
};
